module.exports = __webpack_public_path__ + "img/bg_plan_type_gamer.c3849c23.jpg";